import { render, staticRenderFns } from "./PriceDistributionSection.vue?vue&type=template&id=62cce0ab&"
import script from "./PriceDistributionSection.vue?vue&type=script&lang=js&"
export * from "./PriceDistributionSection.vue?vue&type=script&lang=js&"
import style0 from "./PriceDistributionSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports